<!--
 * @Description: 附件信息
 * @Autor: txp
 * @Date: 2021-04-07 10:54:47
-->
<template>
    <div class="basicformation">
        <div class="title">附件信息</div>
        <div class="content">
            <div v-if="filesVo">
                <ul>
                 <li class="mt8 cursorP" :style="{'color':theme}" @click="downloadfile(item)" v-for="(item,index) in filesVo" :key="index">{{item.fileName}}</li>
              </ul>
            </div>
            <div v-else>无附件</div>
        </div>
    </div>
</template>
<script>
import {download} from '@/utils/index'
import { mapGetters } from 'vuex'
export default {
    name:'basicformation',
    props:['filesVo'],
     computed: {
    ...mapGetters({
      theme: 'theme'
    })
  },
    methods:{
         // 文件下载
    downloadfile(files){
        download(`${files.urlPath}?response-content-type=application/octet-stream`,files.fileName)
    },
    }
}
</script>
<style lang="scss" scoped>
    .basicformation{
        margin: 20px 0px;
        .title{
            font-size: 18px;
            font-weight: 600;
            border-left: 9px solid $color-primary;
            padding-left: 9px;
            height: 18px;
            line-height: 18px;
        }
        .content{
            padding: 20px;
        }
    }
</style>
